import fetch from 'cross-fetch';

import { getTrackingHost } from './get-tracking-host';
/**
 * tracks an ad click on the backend
 *
 * @param {number} id Ad id
 * @param {string} trackingToken tracking token (provided by backend in fetch-ads)
 * @param {string} scrambledId scrambled id (s_id2 cookie) for logged out ads
 */
export async function trackClick(
  id: number,
  trackingToken: string,
  scrambledId?: string
): Promise<string> {
  try {
    // Mock response on localhost, e.g. for demo app
    if (location.hostname === 'localhost') {
      console.info(`Tracking click on ad #${id} with token "${trackingToken}"`);
      return Promise.resolve('stub');
    }

    let requestParams = {
      token: trackingToken,
    };

    let trackingUrl = `/xas/api/ads/${id}/clicks`;

    if (scrambledId) {
      requestParams = {
        ...requestParams,
        ...{ scrambled_id: scrambledId },
      };

      trackingUrl = `${getTrackingHost()}/xas/api/ads/${id}/clicks`;
    }

    await fetch(trackingUrl, {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
      },
      body: JSON.stringify(requestParams),
    });
  } catch (error) {
    throw new Error(error);
  }

  return Promise.resolve('ok');
}
